export const UNSAVED_MODAL_TITLE = 'Are you sure you want to leave this page?'
export const UNSAVED_MODAL_QUESTION = 'Changes that you made will not be saved.'
export const UNSAVED_MODAL_UNSAVED_CHANGES =
  'Do you want to leave this page anyway?'
export const UNSAVED_MODAL_LEAVE_LABEL = 'Yes, leave the page'
